export default "__VITE_ASSET__UYoYGM2c__"